import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Industry from './icon-industry.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Industry {...validProps} />;
}
SvgComponent.iconName = 'industry';

/**
 * @deprecated This is a legacy icon
 */
export const IndustryIcon = svgIconWrapper(SvgComponent);
